export interface FreezeAlertOffset {
  x: number;
  y: number;
}

export interface FreezeAlertRect {
  left: number;
  top: number;
  width: number;
  height: number;
}

/** Keep a dragged freeze card inside the viewport while preserving its stack slot. */
export function clampFreezeAlertOffset(
  startOffset: FreezeAlertOffset,
  startRect: FreezeAlertRect,
  delta: FreezeAlertOffset,
  viewport: { width: number; height: number },
): FreezeAlertOffset {
  const maxLeft = Math.max(0, viewport.width - startRect.width);
  const maxTop = Math.max(0, viewport.height - startRect.height);
  const desiredLeft = startRect.left + delta.x;
  const desiredTop = startRect.top + delta.y;
  const clampedLeft = Math.max(0, Math.min(desiredLeft, maxLeft));
  const clampedTop = Math.max(0, Math.min(desiredTop, maxTop));
  return {
    x: startOffset.x + clampedLeft - startRect.left,
    y: startOffset.y + clampedTop - startRect.top,
  };
}
